import React, { Component, Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { Input, Dialog, Slide } from "@mui/material";
import { compose } from "recompose";
import "views/Pma/PmaEditor/CommonEditor/common.scss";
import { withSnackbar } from "notistack";
import classNames from "classnames";
import { showSuccessNotification } from "common/helpers";
import { showErrorNotification } from "common/helpers";
import { AddUpdatePmaAdmin } from "services/agent";
import { propertyUtil } from "views/Pma/PropertyUtil";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const REPRESENTATION_TEXT_MAX_LENGTH = 50;

const alternatePhotoButtonStyle = {
  padding: "8px 16px",
  backgroundColor: "#e8860a",
  color: "white",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: "bold",
  transition: "opacity 0.15s ease-in-out",
  outline: "none",
  boxShadow: "none",
};

const PropHighlightsAddProperty = (props) => {
  const {
    //representedOptions,
    editPropFormData,
    handleInputChange,
    handleStatusChange,
    openUploadMedia,
    onCloseFn,
    handleAddProperty,
    fromPhotoTable,
    agentData,
    radioSaleChangeFunc,
    userData,
    showAllPropertiesButton = false,
    showButton = true,
  } = props;
  //console.log("**Add property props", editPropFormData);
  const {
    isMemberOfTeam = false,
    agentLicenseNumber = null,
    teamMembers = [],
    brokerageName = "",
  } = agentData || {};
  console.log("agentData", agentData);
  const teamMember1License =
    isMemberOfTeam && teamMembers[0]?.agentLicenseNumber;
  const teamMember2License =
    isMemberOfTeam && teamMembers[1]?.agentLicenseNumber;

  const { formatSuffix } = propertyUtil;

  let isListingAgent = false;

  if (
    (!isMemberOfTeam &&
      agentLicenseNumber === editPropFormData.listingAgentLicenseID) ||
    (isMemberOfTeam &&
      (teamMember1License === editPropFormData.listingAgentLicenseID ||
        teamMember2License === editPropFormData.listingAgentLicenseID)) ||
    (editPropFormData.isCoListingAgent &&
      editPropFormData.isCoListingAgent === "true") ||
    editPropFormData.coListingAgents
  ) {
    isListingAgent = true;
  }
  let isSellingAgent = false;
  if (
    (!isMemberOfTeam &&
      agentLicenseNumber === editPropFormData.sellingAgentLicenseID) ||
    (isMemberOfTeam &&
      (teamMember1License === editPropFormData.sellingAgentLicenseID ||
        teamMember2License === editPropFormData.sellingAgentLicenseID)) ||
    (editPropFormData.isCoSellingAgent &&
      editPropFormData.isCoSellingAgent === "true")
  ) {
    isSellingAgent = true;
  }

  let mapOrder = [];
  if (
    (editPropFormData.isBuyingAgent && editPropFormData.isSellingAgent) ||
    (isSellingAgent && isListingAgent)
  ) {
    mapOrder = ["Buyer/Seller", "Buyer", "Seller"];
  } else if (editPropFormData.isBuyingAgent || isListingAgent) {
    mapOrder = ["Buyer", "Seller", "Buyer/Seller"];
  } else {
    mapOrder = ["Seller", "Buyer/Seller", "Buyer"];
  }

  // Custom handler for property status radio buttons
  const handleStatusRadioChange = (e) => {
    const newStatus = e.target.value;
    let newBannerText2 = "";
    if (newStatus === "Active") newBannerText2 = "Active Listing | Offered at:";
    else if (newStatus === "Pending")
      newBannerText2 = "Pending Sale | Offered at:";
    else if (newStatus === "Contingent")
      newBannerText2 = "Contingent Sale | Offered at:";
    else if (newStatus === "Sold") newBannerText2 = "Sold | Sale Price:";
    else if (newStatus === "Coming Soon") newBannerText2 = "Coming Soon";

    // Update both fields at once using the new object signature
    handleInputChange({
      status: newStatus,
      bannerText2: newBannerText2,
      ...(newStatus === "Coming Soon"
        ? { listPrice: "", salePrice: "" }
        : {}),
    });
  };

  const handleFooterText1Change = (e) => {
    const value = e.target.value;
    const hasBuyers =
      value.includes("Buyer") || value.includes("Buyers");
    const hasSellers =
      value.includes("Seller") || value.includes("Sellers");

    handleInputChange({
      footerText1: value,
      isBuyingAgent: hasBuyers,
      isSellingAgent: hasSellers || (!hasBuyers && !hasSellers),
      ...(!hasBuyers || hasSellers ? { checkedBuyerRepresented: false } : {}),
    });
  };

  // Handler for price input (listPrice and salePrice) to format with commas but store digit-only
  const handlePriceInputChange = (e) => {
    // Remove all non-digit characters
    const rawValue = e.target.value.replace(/[^0-9]/g, "");
    // Allow empty string if user clears the field, otherwise remove leading zeros
    const cleanValue =
      rawValue === "" ? "" : rawValue.replace(/^0+/, "") || "0";
    handleInputChange({
      [e.target.name]: cleanValue,
    });
  };

  const isBuyerRepresented =
    editPropFormData.footerText1 &&
    (editPropFormData.footerText1.includes("Buyer") ||
      editPropFormData.footerText1.includes("Buyers"));

  const getTextLength = (value) => (value == null ? "" : String(value)).length;

  const footerText2Length = getTextLength(editPropFormData.footerText2);
  const footerText1Length = getTextLength(editPropFormData.footerText1);

  const footerText2OverLimit = footerText2Length > 60;
  const footerText1OverLimit =
    footerText1Length > REPRESENTATION_TEXT_MAX_LENGTH;

  const disableSubmitOverCharLimit =
    footerText2OverLimit || footerText1OverLimit;

  // Logic to disable submit if buyer represented but no courtesy text
  // Exception: If permission is "with-permission" or "own-rights", courtesy text is not required
  const disableSubmitNoCourtesy =
    isBuyerRepresented &&
    editPropFormData.buyerPermissionType !== "with-permission" &&
    editPropFormData.buyerPermissionType !== "own-rights" &&
    (!editPropFormData.courtesyText1 ||
      editPropFormData.courtesyText1.trim() === "");

  // Combined disable logic
  const disableSubmitButton =
    disableSubmitOverCharLimit || disableSubmitNoCourtesy;

  const saveButtonStyle = {
    opacity: disableSubmitButton ? 0.5 : 1,
    backgroundColor: disableSubmitButton ? "#b0b0b0" : "#4e85af",
  };

  const renderSaveButton = (label, oneAreaSubmit) => (
    <button
      type="button"
      className={`photo-edit-form-submit-button${
        disableSubmitButton ? " disabled" : ""
      }`}
      disabled={disableSubmitButton}
      onClick={() => handleAddProperty(oneAreaSubmit)}
      style={saveButtonStyle}
    >
      <p>{label}</p>
    </button>
  );

  return (
    <Fragment>
      <Dialog
        open={true}
        //onClose={onCloseFn}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
        fullWidth={true}
        TransitionComponent={Transition}
      >
        <div
          className={`${
            fromPhotoTable
              ? "photo-table-photo-edit-property-container"
              : "photo-edit-property-container"
          }`}
        >
          <div className="photo-edit-property-title-container">
            <p className="photo-edit-property-title">Add a Property</p>
            <div className="photo-edit-property-title-divider" />
            <p className="photo-edit-property-subtitle-text">
              Add a Property that was sold Off-Market or is not shown on the
              list
            </p>
          </div>
          <div className="photo-edit-property-form new-props">
            <div className="photo-edit-property-form-title-container">
              <p className="photo-edit-property-form-title-text">
                Input Property Details Here:
              </p>
              <div className="photo-edit-property-form-title-divider"></div>
            </div>

            <div className="photo-edit-property-form-body">
              <div className="photo-edit-form-body-col">
                <div className="photo-edit-form-thead">
                  <div className="photo-edit-form-thead-col property-details-thead">
                    <p>Property Details Under Photo</p>
                  </div>
                  <div className="photo-edit-form-thead-col footer-text-thead">
                    <p>Property Representation</p>
                  </div>
                  {editPropFormData.footerText1 &&
                    (editPropFormData.footerText1.includes("Buyer") ||
                      editPropFormData.footerText1.includes("Buyers")) && (
                      <div className="photo-edit-form-thead-col photo-courtesy-thead">
                        <p>Photo Courtesy Of:</p>
                      </div>
                    )}
                  <div className="photo-edit-form-thead-col mls-photo-thead">
                    <p>Photo</p>
                  </div>
                </div>
                <div className="photo-edit-form-input">
                  <div className="photo-edit-form-input-col property-details-input-col">
                    <input
                      className="property-details-input"
                      type="text"
                      id="bannerText1"
                      name="bannerText1"
                      value={editPropFormData.bannerText1 || ""}
                      onChange={handleInputChange}
                      placeholder="Address"
                    ></input>

                    {/* Property Status Radio Buttons */}
                    <div
                      className="property-status-container"
                      style={{
                        marginTop: "10px",
                        textAlign: "left",
                      }}
                    >
                      <div
                        className="property-status-option"
                        style={{ textAlign: "left" }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "5px",
                            justifyContent: "flex-start",
                          }}
                        >
                          <input
                            type="radio"
                            name="status"
                            value="Active"
                            checked={editPropFormData.status === "Active"}
                            onChange={handleStatusRadioChange}
                            style={{ marginRight: "8px", minWidth: "16px" }}
                          />
                          <span>Active Listing</span>
                        </label>
                      </div>
                      <div
                        className="property-status-option"
                        style={{ textAlign: "left" }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "5px",
                            justifyContent: "flex-start",
                          }}
                        >
                          <input
                            type="radio"
                            name="status"
                            value="Pending"
                            checked={editPropFormData.status === "Pending"}
                            onChange={handleStatusRadioChange}
                            style={{ marginRight: "8px", minWidth: "16px" }}
                          />
                          <span>Pending Sale</span>
                        </label>
                      </div>
                      <div
                        className="property-status-option"
                        style={{ textAlign: "left" }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "5px",
                            justifyContent: "flex-start",
                          }}
                        >
                          <input
                            type="radio"
                            name="status"
                            value="Contingent"
                            checked={editPropFormData.status === "Contingent"}
                            onChange={handleStatusRadioChange}
                            style={{ marginRight: "8px", minWidth: "16px" }}
                          />
                          <span>Contingent Sale</span>
                        </label>
                      </div>
                      <div
                        className="property-status-option"
                        style={{ textAlign: "left" }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "5px",
                            justifyContent: "flex-start",
                          }}
                        >
                          <input
                            type="radio"
                            name="status"
                            value="Sold"
                            checked={editPropFormData.status === "Sold"}
                            onChange={handleStatusRadioChange}
                            style={{ marginRight: "8px", minWidth: "16px" }}
                          />
                          <span>Sold</span>
                        </label>
                      </div>
                      <div
                        className="property-status-option"
                        style={{ textAlign: "left" }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "5px",
                            justifyContent: "flex-start",
                          }}
                        >
                          <input
                            type="radio"
                            name="status"
                            value="Coming Soon"
                            checked={editPropFormData.status === "Coming Soon"}
                            onChange={handleStatusRadioChange}
                            style={{ marginRight: "8px", minWidth: "16px" }}
                          />
                          <span>Coming Soon</span>
                        </label>
                      </div>
                    </div>

                    {/* BannerText2 and Price Input: Only show if status is selected */}
                    {editPropFormData.status && (
                      <div className="banner-text2-container">
                        <input
                          className="property-details-input"
                          type="text"
                          id="bannerText2"
                          name="bannerText2"
                          value={editPropFormData.bannerText2 || ""}
                          onChange={handleInputChange}
                          placeholder="Status and Price"
                        />
                        {editPropFormData.status !== "Coming Soon" && (
                          <div className="price-input-container">
                            <span style={{ fontWeight: "bold" }}>$</span>
                            <input
                              className="property-details-input"
                              type="text"
                              id="priceInput"
                              name="priceInput"
                              value={
                                editPropFormData.status === "Sold"
                                  ? editPropFormData.salePrice !== undefined &&
                                    editPropFormData.salePrice !== null &&
                                    editPropFormData.salePrice !== "" &&
                                    editPropFormData.salePrice !== "0"
                                    ? Number(
                                        editPropFormData.salePrice,
                                      ).toLocaleString()
                                    : ""
                                  : editPropFormData.listPrice !== undefined &&
                                      editPropFormData.listPrice !== null &&
                                      editPropFormData.listPrice !== "" &&
                                      editPropFormData.listPrice !== "0"
                                    ? Number(
                                        editPropFormData.listPrice,
                                      ).toLocaleString()
                                    : ""
                              }
                              onChange={(e) => {
                                // Use the handler for digit-only storage
                                if (editPropFormData.status === "Sold") {
                                  handlePriceInputChange({
                                    target: {
                                      name: "salePrice",
                                      value: e.target.value,
                                    },
                                  });
                                } else {
                                  handlePriceInputChange({
                                    target: {
                                      name: "listPrice",
                                      value: e.target.value,
                                    },
                                  });
                                }
                              }}
                              placeholder={
                                editPropFormData.status === "Sold"
                                  ? "Sale Price"
                                  : "List Price"
                              }
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="photo-edit-form-input-col footer-text-input-col">
                    {editPropFormData.status && (
                      <div style={{ marginBottom: 8 }}>
                        <input
                          className="footer-text-input"
                          type="text"
                          id="footerText1"
                          name="footerText1"
                          value={editPropFormData.footerText1 ?? ""}
                          onChange={handleFooterText1Change}
                          placeholder="Property Representation"
                          maxLength={REPRESENTATION_TEXT_MAX_LENGTH}
                          style={{
                            color: footerText1OverLimit ? "#dc3545" : "inherit",
                            width: "200px",
                          }}
                        />
                        <div
                          style={{
                            fontSize: "11px",
                            marginTop: "4px",
                            color: footerText1OverLimit ? "#dc3545" : "#666",
                            fontStyle: "italic",
                          }}
                        >
                          {footerText1Length}/{REPRESENTATION_TEXT_MAX_LENGTH}{" "}
                          characters
                        </div>
                        {footerText1OverLimit && (
                          <div
                            style={{
                              fontSize: "11px",
                              marginTop: "4px",
                              color: "#dc3545",
                              fontWeight: 500,
                            }}
                          >
                            Property Representation cannot exceed{" "}
                            {REPRESENTATION_TEXT_MAX_LENGTH} characters
                          </div>
                        )}
                      </div>
                    )}
                    <div>
                      <input
                        className="footer-text-input"
                        type="text"
                        id="footerText2"
                        name="footerText2"
                        value={editPropFormData.footerText2 || ""}
                        onChange={handleInputChange}
                        placeholder="Optional Text"
                        maxLength={60}
                        style={{
                          color: footerText2OverLimit ? "#dc3545" : "inherit",
                          width: "200px",
                        }}
                      ></input>
                      <div
                        style={{
                          fontSize: "11px",
                          marginTop: "4px",
                          color: footerText2OverLimit ? "#dc3545" : "#666",
                          fontStyle: "italic",
                        }}
                      >
                        {footerText2Length}/60 characters
                      </div>
                      {footerText2OverLimit && (
                        <div
                          style={{
                            fontSize: "11px",
                            marginTop: "4px",
                            color: "#dc3545",
                            fontWeight: 500,
                          }}
                        >
                          Optional Text cannot exceed 60 characters
                        </div>
                      )}
                    </div>
                  </div>
                  {editPropFormData.footerText1 &&
                    (editPropFormData.footerText1.includes("Buyer") ||
                      editPropFormData.footerText1.includes("Buyers")) && (
                      <div className="photo-edit-form-input-col photo-courtesy-input-col">
                        {/* CourtesyText1 Input - Only show if footerText1 contains "Buyer" or "Buyers" */}
                        <div>
                          <input
                            className="photo-courtesy-input"
                            type="text"
                            id="courtesyText1"
                            name="courtesyText1"
                            value={
                              editPropFormData.courtesyText1 !== undefined &&
                              editPropFormData.courtesyText1 !== null
                                ? editPropFormData.courtesyText1
                                : `Image courtesy of ${
                                    editPropFormData.brokerageName || ""
                                  }`
                            }
                            onChange={handleInputChange}
                            placeholder="Courtesy Text 1"
                            style={{
                              color: "inherit",
                            }}
                          ></input>
                          <div
                            style={{
                              fontSize: "11px",
                              color: "#666",
                              marginTop: "4px",
                              fontStyle: "italic",
                            }}
                          >
                            {
                              (
                                (editPropFormData.courtesyText1 !== undefined &&
                                editPropFormData.courtesyText1 !== null
                                  ? editPropFormData.courtesyText1
                                  : `Image courtesy of ${
                                      editPropFormData.brokerageName || ""
                                    }`) || ""
                              ).length
                            }{" "}
                            characters
                          </div>
                          <div
                            style={{
                              fontSize: "11px",
                              color: "#666",
                              marginTop: "4px",
                              fontStyle: "italic",
                            }}
                          >
                            Example: Image courtesy of {brokerageName}
                          </div>
                        </div>

                        {/* Buyer Permission Radio Buttons - Only show if footerText1 contains "Buyer" or "Buyers" */}
                        <div className="buyer-permission-container">
                          <div className="buyer-permission-option">
                            <label className="buyer-represented-radio-label">
                              <input
                                type="radio"
                                name="buyerPermission"
                                value="with-permission"
                                checked={
                                  editPropFormData.buyerPermissionType ===
                                  "with-permission"
                                }
                                onChange={(e) =>
                                  handleInputChange({
                                    buyerPermissionType: e.target.value,
                                    checkedBuyerRepresented: true,
                                    buyerRepresentedReason: e.target.value,
                                  })
                                }
                                className="buyer-represented-radio"
                              />
                              <span className="buyer-represented-radio-text">
                                I represented the Buyer and I have permission
                                from the listing agent to use the photo
                              </span>
                            </label>
                          </div>
                          <div className="buyer-permission-option">
                            <label className="buyer-represented-radio-label">
                              <input
                                type="radio"
                                name="buyerPermission"
                                value="own-rights"
                                checked={
                                  editPropFormData.buyerPermissionType ===
                                  "own-rights"
                                }
                                onChange={(e) =>
                                  handleInputChange({
                                    buyerPermissionType: e.target.value,
                                    checkedBuyerRepresented: true,
                                    buyerRepresentedReason: e.target.value,
                                  })
                                }
                                className="buyer-represented-radio"
                              />
                              <span className="buyer-represented-radio-text">
                                I represented the Buyer and I own the rights to
                                the photo (No listing agent permission required)
                              </span>
                            </label>
                          </div>
                          <div className="buyer-permission-option">
                            <label className="buyer-represented-radio-label">
                              <input
                                type="radio"
                                name="buyerPermission"
                                value="no-permission"
                                checked={
                                  editPropFormData.buyerPermissionType ===
                                  "no-permission"
                                }
                                onChange={(e) =>
                                  handleInputChange({
                                    buyerPermissionType: e.target.value,
                                    checkedBuyerRepresented: true,
                                    buyerRepresentedReason: e.target.value,
                                  })
                                }
                                className="buyer-represented-radio"
                              />
                              <span className="buyer-represented-radio-text">
                                I represented the Buyer and I don't have
                                permission
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}

                  <div className="photo-edit-form-input-col photo-td mls-photo-input-col">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {editPropFormData.justAdded && (
                        <div className="mls-photo-input">
                          <div className="add-photo-container no-hover">
                            <img
                              src={editPropFormData.optimizedPhotoURL}
                              alt="Home"
                            />
                          </div>
                        </div>
                      )}
                      {editPropFormData.justAdded ? (
                        <button
                          type="button"
                          onClick={() =>
                            openUploadMedia(
                              editPropFormData.displayOrder,
                              editPropFormData.photoURL,
                            )
                          }
                          style={alternatePhotoButtonStyle}
                        >
                          Click to Upload Alternate Photo
                        </button>
                      ) : (
                        <div
                          className="add-photo-container add-prop mls-photo-input"
                          onClick={() =>
                            openUploadMedia(
                              editPropFormData.displayOrder,
                              editPropFormData.photoURL,
                            )
                          }
                        >
                          <p>Click to</p>
                          <p>Upload Photo</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="photo-edit-form-button-container"
            style={{ justifyContent: "center", gap: "20px" }}
          >
            <button
              type="button"
              className="photo-edit-form-cancel-button"
              onClick={onCloseFn}
            >
              <p>Cancel</p>
            </button>
            {showAllPropertiesButton &&
              renderSaveButton("Save for All Areas", false)}
            {showButton && renderSaveButton("Save for This Area Only", true)}
          </div>
          {disableSubmitNoCourtesy && (
            <div
              style={{
                color: "#dc3545",
                textAlign: "center",
                marginTop: "8px",
                marginBottom: "10px",
                fontWeight: 500,
              }}
            >
              Buyer represented properties must have an Image Courtesy
            </div>
          )}
        </div>
      </Dialog>
    </Fragment>
  );
};

export default compose(withSnackbar)(PropHighlightsAddProperty);
